module.exports = __webpack_public_path__ + "static/media/more.e603b8bd.svg";